/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/

import { consumirServicioEncirptacion } from 'api';
import classNames from 'classnames';
import ResumenDatosSeguro from 'components/APIndividual/ResumenDatosSeguro';
import { SimpleMaskInputField, SimplePasswordInputField } from 'components/InputsMex/SimpleInputs';
import SimpleContainer from 'components/InputsMex/containers/SimpleContainer';
import { emailRegex } from 'components/InputsMex/validaciones';
import { ambienteAplicacion, urlPago } from 'constants/urls';
import { CASUALITY_GENERAL } from 'containers/Casuality-General/constantes';
import { CASUALITY } from 'containers/Casuality/constantes';
import { LF } from 'containers/LineasFinancieras/Constantes/general';
import CancelarTokenCorreo from 'containers/Polizas/TestPago/CancelarTokenCorreo';
import { SEGUKIDS } from 'containers/Segurykids/constants';
import { useAccionesPantallaPago, usePantallaPago } from 'contexts/FormPagoContext';
import useCustomToast from 'hooks/useCustomToasts';
import useQueryParams from 'hooks/useQueryParams';
import moment from 'moment';
import { Button } from 'primereact/button';
import React, { useEffect, useMemo, useState } from 'react';
import { Controller, FormProvider, useForm, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import PRODUCTOS from 'utils/constants/PRODUCTOS';
import { DropDown, TextInput, TextInputMask } from '../InputsMex/inputs';
import SeleccionarTarjeta from './FormPago/SeleccionarTarjeta';

const getMsgCorreoCobro = (correo) => {
  return `Hemos enviado un correo de solicitud de cobro a la dirección ${correo} correctamente`;
};

const FormPago = ({
  idPoliza,
  enviando,
  emailContratante,
  onClickContinuar,
  datosTarifacion,
  showCVV,
  codProducto,
  pagoTradicional = false,
  banderaPrimerPago,
  catalogo,
  newRoutes,
  estadoGeneral,
}) => {
  const methods = useFormContext();

  const methodsCorreo = useForm({
    mode: 'onChange',
    defaultValues: { correo: emailContratante },
  });

  const [enviandoCorreo, setEnviandoCorreo] = useState(false);
  const history = useHistory();
  const [banco, setBanco] = useState(null);
  const [tarjeta, setTarjeta] = useState(null);

  const [numTarjeta, setNumTarjeta] = useState('');

  const [verificada, setVerificada] = useState(false);

  const { addWarningToast, addSuccessToast } = useCustomToast();

  const [buscandoTarjeta, buscarTarjeta] = useState(false);

  const [showForm, setShowForm] = useState(false);

  const [showCombo, setShowCombo] = useState(false);

  const [showTarjeta, setShowTarjeta] = useState(false);

  const { dataUsuario } = useSelector((state) => state.datosUsuarios);

  const [cvvLongitud, setCvvLongitud] = useState(3);

  const { ingreso } = useQueryParams();

  const statePantalla = usePantallaPago();
  const accionesPantalla = useAccionesPantallaPago();

  const isCorreoDesactivado = useMemo(
    () =>
      [
        PRODUCTOS.HOGAR,
        PRODUCTOS.HOGAR_FLEX,
        // PRODUCTOS.PYMES,
        // PRODUCTOS.pymesAbiertoInd,
        PRODUCTOS.RCP,
        PRODUCTOS.CYBER,
        PRODUCTOS.PRESUSCRITOS,
        PRODUCTOS.DO,
        // PRODUCTOS.CASUALITY_GENERAL,
        PRODUCTOS.SEGUKIDS,
      ].includes(codProducto),
    [codProducto]
  );

  useEffect(() => {
    if (ingreso && dataUsuario.usu_tipo_usuario === 'cliente') {
      setShowTarjeta(true);
    } else {
      if (!dataUsuario || !dataUsuario.userIsLoggedIn) {
        return setShowTarjeta(true);
      }
      if (dataUsuario.usu_tipo_usuario !== 'cliente') {
        if (isCorreoDesactivado) {
          setShowCombo(false);
          setShowTarjeta(pagoTradicional === false);
          return;
        }
        setShowCombo(true);
      } else {
        if (isCorreoDesactivado) {
          setShowCombo(false);
          setShowTarjeta(pagoTradicional === false);
          return;
        }

        setShowCombo(false);
        setShowTarjeta(true);
      }
    }
  }, []);

  const onClickVerificar = async () => {
    const numTarjetaForm = methods.getValues('numTarjeta');
    const valid = await methods.trigger('numTarjeta');

    if (valid) {
      buscarTarjeta(true);
      setShowForm(false);
      const Data = {
        datosPago: {
          ambiente: ambienteAplicacion,
          cotPasoCodigo: 'validarTarjeta',
          polCodigo: idPoliza,
          numTarjeta: numTarjetaForm,
          isFromLinkCobro: statePantalla.isFromLinkCobro,
          // tokenCorreo: statePantalla.tokenCorreo,
          // sessionId: statePantalla.sessionId,
        },
      };

      try {
        const res = await consumirServicioEncirptacion(urlPago, Data);
        console.log('RES VALIDAR: ', res);

        if (res?.transaccion === false && res?.errorType === 'validacion-continuar-pago') {
          addWarningToast(res?.message);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
          return;
        }

        if (res.transaccion) {
          if (res?.pago?.datosTarjeta) {
            setBanco(res.pago.datosTarjeta.bancoNombre);
            setTarjeta(res.pago.datosTarjeta.tipoTarjeta);
            setCvvLongitud(res?.pago?.datosTarjeta?.longitudCvv);
            setShowForm(true);
            setVerificada(true);
            setNumTarjeta(numTarjetaForm);
          } else {
            if (res?.pago?.msgError) {
              //ENTRA AQUI EN CASO DE QUE  EL PAGO YA FUE REALIZADO.
              if (Array.isArray(res.pago.msgError)) {
                res.pago.msgError.forEach((msg) => addWarningToast(msg, { autoDismiss: false }));
                //FLUJO DE VALIDACION DE DOBLE PAGO.
                if (res?.pagp?.validacionBanco) {
                  onClickContinuar();
                }
              }
            } else {
              addWarningToast('Algo ha salido mal');
            }
          }
        } else {
          if (res?.pago?.error_Message) {
            addWarningToast(res?.pago?.error_Message);
          } else {
            addWarningToast('Algo ha salido mal, verifica tus datos');
          }
        }

        buscarTarjeta(false);
      } catch (error) {
        buscarTarjeta(false);
        addWarningToast('Algo ha salido mal');
      }
    } else {
      addWarningToast('Ingrese un número de tarjeta válido');
    }
  };

  const onClickEnviarCorreo = async (data) => {
    setEnviandoCorreo(true);
    accionesPantalla.setState({ enviandoLinkCobro: true });
    const Data = {
      datosPago: {
        ambiente: ambienteAplicacion,
        cotPasoCodigo: 'enviarCorreoPago',
        polCodigo: idPoliza,
        codProducto,
        email: data.correo,
        url: window.location.href,
      },
    };

    const DataSaltarPago = {
      datosPago: {
        ambiente: ambienteAplicacion,
        cotPasoCodigo: 'saltarTarjetaBroker',
        polCodigo: idPoliza,
      },
    };

    const promises = [
      consumirServicioEncirptacion(urlPago, Data),
      consumirServicioEncirptacion(urlPago, DataSaltarPago),
    ];

    const [res, resSaltar] = await Promise.all(promises);

    if (res.transaccion && resSaltar.transaccion) {
      addSuccessToast(getMsgCorreoCobro(data.correo));
      accionesPantalla.setState({
        showFormPago: false,
        showFormCancelarTokens: true,
        enviandoLinkCobro: false,
      });
    } else {
      addWarningToast('Ha ocurrido un problema al enviar el correo, por favor intente nuevamente');
    }

    setEnviandoCorreo(false);
  };

  const medioPago = methods.watch('ingresoTarjeta');
  const tipoPago = methods.watch('tipoPago', 'online');
  const tarjetaSeleccionada = methods.watch('tarjetaSeleccionada');

  const onChangeTipoTarjeta = (onChange) => (value) => {
    onChange(value);
    methods.setValue('numTarjeta', null, {
      shouldDirty: false,
      shouldValidate: false,
    });
    setShowForm(false);
    setNumTarjeta(null);
  };

  const handleSeleccionarTipoPago = (tipoPagoParam) => {
    setVerificada(false);
    setShowForm(false);

    if (isCorreoDesactivado) {
      if (tipoPagoParam === 'online') {
        setShowCombo(false);
        setShowTarjeta(true);
      } else {
        setShowCombo(false);
        setShowTarjeta(false);
      }
    }
  };

  return (
    <React.Fragment>
      <div className="row justify-content-center mt-2">
        <div
          className={`${
            PRODUCTOS.SEGUKIDS === codProducto ? 'col-sm-12' : 'col-sm-11 card-login-mex'
          }`}
        >
          <div className="row">
            <div className="col-lg-6 order-1 order-lg-0">
              <div className="m-0 m-md-4 m-xl-5 ">
                {statePantalla.showFormPago === true && (
                  <React.Fragment>
                    {catalogo?.mensajeAlertaPago && (
                      <p className="font-20px">{catalogo?.mensajeAlertaPago}</p>
                    )}
                    {pagoTradicional && !ingreso && dataUsuario.userIsLoggedIn && (
                      <div className="col-md-10 my-4">
                        <SimpleContainer name="tipoPago" label="Selecciona el tipo de pago">
                          <DropDown
                            name="tipoPago"
                            options={[
                              {
                                label: 'Pago en línea',
                                value: 'online',
                              },
                              PRODUCTOS.SEGUKIDS === codProducto
                                ? {
                                    label: 'Pago por línea de captura',
                                    value: 'tradicional',
                                  }
                                : {
                                    label: 'Pago referenciado',
                                    value: 'tradicional',
                                  },
                            ]}
                            disabled={enviando}
                            onChangeFn={handleSeleccionarTipoPago}
                          />
                        </SimpleContainer>
                      </div>
                    )}
                    {showCombo && tipoPago === 'online' && (
                      <div className="col-md-10">
                        <SimpleContainer label="Selecciona el medio de pago" name="ingresoTarjeta">
                          <DropDown
                            name="ingresoTarjeta"
                            options={[
                              {
                                label: 'Enviar correo a cliente para solicitar pago',
                                value: 'correo',
                              },
                              {
                                label: 'Ingresar tarjeta',
                                value: 'tarjeta',
                              },
                            ]}
                            rules={{
                              required: 'Este campo es obligatorio',
                            }}
                            disabled={enviando}
                          />
                        </SimpleContainer>
                      </div>
                    )}

                    {(medioPago === 'tarjeta' || showTarjeta) && (
                      <React.Fragment>
                        <h3 className="font-mex mt-5 ml-2 ml-sm-0">Información de tarjeta</h3>

                        <div className="form-row">
                          <Controller
                            name="tarjetaSeleccionada"
                            defaultValue={null}
                            render={({ value, onChange }) => (
                              <SeleccionarTarjeta
                                setTarjetaSeleccionada={onChangeTipoTarjeta(onChange)}
                                tarjetaSeleccionada={value?.typeName}
                              />
                            )}
                          />
                          {tarjetaSeleccionada && (
                            <div className="col-12 ">
                              <div className="row justify-content-center form-group">
                                <div className="col-12 col-md-8 ">
                                  <SimpleMaskInputField
                                    name="numTarjeta"
                                    label="Número de tarjeta"
                                    unmask
                                    disabled={buscandoTarjeta || enviando}
                                    rules={{
                                      required: 'Este campo es obligatorio',
                                      validate: {
                                        length: (value) => {
                                          if (value.length !== tarjetaSeleccionada.length) {
                                            setShowForm(false);
                                            setNumTarjeta('');
                                            return 'Por favor ingrese todos los números de la tarjeta';
                                          }
                                          return true;
                                        },
                                        diff: (value) => {
                                          if (verificada && numTarjeta !== value) {
                                            setShowForm(false);
                                            setVerificada(false);
                                            setNumTarjeta('');
                                          }

                                          return true;
                                        },
                                      },
                                    }}
                                    {...tarjetaSeleccionada}
                                  />
                                </div>
                                <div className="col-11 col-md-4 align-self-end">
                                  <button
                                    disabled={
                                      buscandoTarjeta || verificada || estadoGeneral?.bloquearPago
                                    }
                                    className="btn btn-siguiente-api text-uppercase"
                                    type="button"
                                    onClick={onClickVerificar}
                                  >
                                    {buscandoTarjeta ? 'Validando...' : 'Validar'}
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                          {showForm && (
                            <React.Fragment>
                              <div className="col-md-12 ml-4 form-group">
                                <h6>
                                  {banco} {tarjeta && `- ${tarjeta}`}
                                </h6>
                              </div>

                              <div className="col-md-12 form-group">
                                <SimpleContainer label="Nombre del titular" name="titular">
                                  <TextInput
                                    inputProps={{ name: 'titular' }}
                                    rules={{
                                      required: 'Este campo es obligatorio',
                                    }}
                                  />
                                </SimpleContainer>
                              </div>

                              <div className="col-md-6 form-group">
                                <SimpleContainer label="Vencimiento" name="expiracion">
                                  <TextInputMask
                                    mask="99/9999"
                                    placeholder="mm/aaaa"
                                    name="expiracion"
                                    //unmask={false}
                                    unmask={false}
                                    rules={{
                                      required: 'Este campo es obligatorio',
                                      validate: (value) => {
                                        if (value.includes('_')) {
                                          return 'Debe ingresar los 6 digitos';
                                        } else {
                                          const mes = moment().get('M') + 1;
                                          const anio = moment().get('y');
                                          const mesExpiracion = Number(value.split('/')[0]);
                                          const anioExpiracion = Number(value.split('/')[1]);

                                          const anioValido = anio + 10;

                                          if (mesExpiracion < 1 || mesExpiracion > 12) {
                                            return 'Ingrese un mes válido';
                                          }

                                          if (
                                            anioExpiracion < anio ||
                                            anioExpiracion > anioValido
                                          ) {
                                            return `Ingrese un año válido entre ${anio} y ${anioValido}`;
                                          }

                                          if (anioExpiracion === anio) {
                                            if (mesExpiracion < mes) {
                                              return 'La fecha de expiración debe ser mayor o igual a la fecha actual';
                                            }
                                          }

                                          if (anioExpiracion < anio) {
                                            return 'La fecha de expiración debe ser mayor o igual a la fecha actual';
                                          }
                                        }
                                        return true;
                                      },
                                    }}
                                  />
                                </SimpleContainer>
                              </div>

                              {showCVV && (
                                <div className="col-md-6 form-group">
                                  <SimplePasswordInputField
                                    label="CVV"
                                    name="cvv"
                                    type="number"
                                    isInt
                                    rules={{
                                      required: 'Este campo es obligatorio',
                                      maxLength: {
                                        value: cvvLongitud,
                                        message: `Solo se puede ingresar ${cvvLongitud} números`,
                                      },
                                      minLength: {
                                        value: cvvLongitud,
                                        message: `Debe ingresar ${cvvLongitud} números`,
                                      },
                                    }}
                                  />
                                </div>
                              )}
                            </React.Fragment>
                          )}
                        </div>
                      </React.Fragment>
                    )}

                    {medioPago === 'correo' && (
                      <React.Fragment>
                        <FormProvider {...methodsCorreo}>
                          <div className="col-md-10 mt-4 d-flex flex-column justify-content-center">
                            <SimpleContainer label="Enviar información a" name="correo">
                              <TextInput
                                inputProps={{
                                  name: 'correo',
                                  disabled: enviandoCorreo,
                                }}
                                hideArrows
                                rules={{
                                  required: 'Este campo es obligatorio',
                                  pattern: {
                                    value: emailRegex,
                                    message: 'Ingrese un correo válido',
                                  },
                                }}
                              />
                            </SimpleContainer>

                            <Button
                              className="p-button-primary mt-2 mx-auto px-3"
                              type="button"
                              onClick={methodsCorreo.handleSubmit(onClickEnviarCorreo)}
                              disabled={enviandoCorreo}
                              label={enviandoCorreo ? 'Enviando...' : 'Enviar'}
                            />
                          </div>
                        </FormProvider>
                      </React.Fragment>
                    )}

                    {tipoPago === 'tradicional' && (
                      <h1 className="font-20px">
                        Realiza tu pago en los establecimientos autorizados que encontrarás en el
                        recibo de cobro con el número de referencia emitido con tu póliza.
                      </h1>
                    )}
                  </React.Fragment>
                )}
                {statePantalla.showFormCancelarTokens === true && <CancelarTokenCorreo />}
              </div>
            </div>

            <div className="col-11 col-lg-6 order-0 order-lg-1">
              <div className="m-0 m-md-4 m-xl-5">
                <ResumenDatosSeguro datosTarifacion={datosTarifacion} codProducto={codProducto} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center ">
        <div className="col-sm-11 col-lg-10">
          <div
            className={`${
              PRODUCTOS.SEGUKIDS === codProducto
                ? 'row justify-content-center'
                : 'row justify-content-around'
            }`}
          >
            {methods.watch('tipoPago') === 'online' && (
              <div
                className={classNames('col-11 col-md-6 col-lg-4 mt-3', {
                  'd-none': ![
                    PRODUCTOS.HOGAR,
                    PRODUCTOS.HOGAR_DTC,
                    PRODUCTOS.HOGAR_FLEX,
                    PRODUCTOS.LINEAS_FINANCIERAS,
                    PRODUCTOS.RCP,
                    PRODUCTOS.CYBER,
                    PRODUCTOS.MARINE_INLAND,
                    PRODUCTOS.DO,
                    PRODUCTOS.CASUALITY,
                    PRODUCTOS.CASUALITY_GENERAL,
                    PRODUCTOS.AUTO,
                    PRODUCTOS.SEGUKIDS,
                  ].includes(codProducto),
                })}
              >
                <button
                  className={`btn btn-block btn-block font-source-sans-regular py-2 text-white bg-mex border-mex  ${
                    PRODUCTOS.SEGUKIDS === codProducto ? 'btn-segukids' : ''
                  }`}
                  type="button"
                  onClick={() => {
                    if (codProducto === PRODUCTOS.LINEAS_FINANCIERAS) {
                      return history.push(`${LF.urls.vigencia}?idPoliza=${idPoliza}`);
                    }

                    if (codProducto === PRODUCTOS.CASUALITY) {
                      return history.push(`${CASUALITY.urls.contratante}?id=${idPoliza}`);
                    }
                    if (codProducto === PRODUCTOS.CASUALITY_GENERAL) {
                      return history.push(`${CASUALITY_GENERAL.urls.vigencia}?id=${idPoliza}`);
                    }
                    if (codProducto === PRODUCTOS.SEGUKIDS) {
                      return history.push(`${SEGUKIDS.urls.asegurado}?idPoliza=${idPoliza}`);
                    }

                    return history.push(newRoutes.suscripcion.goBack);
                  }}
                  disabled={enviando}
                >
                  {PRODUCTOS.SEGUKIDS === codProducto && (
                    <i
                      className="pi pi-arrow-left"
                      style={{
                        position: 'relative',
                        top: '1px',
                        fontSize: '1.4rem',
                        paddingRight: '5px',
                      }}
                    />
                  )}
                  ATRÁS
                </button>
              </div>
            )}
            {verificada && (
              <div className="col-11 col-md-6 col-lg-4 mt-3">
                <button
                  className={`btn btn-block btn-block font-source-sans-regular py-2 text-white bg-mex border-mex ${
                    PRODUCTOS.SEGUKIDS === codProducto ? 'btn-segukids' : ''
                  }`}
                  type="submit"
                  disabled={enviando}
                >
                  {enviando ? 'PROCESANDO...' : 'CONTINUAR'}
                  {PRODUCTOS.SEGUKIDS === codProducto && (
                    <i
                      className="pi pi-arrow-right"
                      style={{
                        position: 'relative',
                        top: '1px',
                        fontSize: '1.4rem',
                        paddingLeft: '5px',
                      }}
                    />
                  )}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FormPago;
